<template>
    <div>
        <transition name="fade">
            <div class="cart-loader" v-if="status.loading || status.deleting" v-text="status.loading ? 'Загружаем товары' : 'Удаляем товар'"></div>
        </transition>
        
        <div class="cart-alert alert alert--info" v-if="!status.loading && items.length === 0">Корзина пуста</div>
        <div v-if="items.length > 0">
            <div class="cart-item" v-for="(item, index) in items" :key="index">
                <div class="cart-item__name" v-html="
                    item?.type == 'constructor'
                    ? `Сформированная цепь<br><strong>${item.chain}</strong>`
                    : `${item?.fullname}<br><strong>${item?.name}</strong>`
                "></div>
                <div class="cart-item__info">
                    <div class="cart-item__comment" v-if="item?.comment">
                        <strong>Дополнительная информация</strong>:
                        <span class="cart-item__comment-text" v-text="item?.comment"></span>
                        <span class="cart-item__edit-wrap">
                            &nbsp;<a class="cart-item__edit" href="javascript:" @click="editComment(item, index)">
                                <svg-symbol name="edit" class="cart-item__edit-icon"></svg-symbol> Изменить</a>
                        </span>
                    </div>
                    <div class="cart-item__comment" v-else>
                        <span class="cart-item__edit-wrap">
                            &nbsp;<a class="cart-item__edit" href="javascript:" @click="editComment(item, index)">
                                <svg-symbol name="edit" class="cart-item__edit-icon"></svg-symbol> Добавить комментарий
                            </a>
                        </span>
                    </div>
                    <div class="cart-item__additional-info" v-html="item?.info" v-if="item?.type == 'constructor'"></div>
                </div>
                <div class="cart-item__delete-btn-wrap">
                    <button type="button" class="btn cart-item__delete" @click="deleteItem(index)">
                        <svg-symbol name="trash" class="cart-item__delete-icon"></svg-symbol>
                        Удалить
                    </button>
                </div>
            </div>
            <button type="button" class="btn cart__btn-order" @click="send">Оформить заказ</button>
        </div>
        <modals-container></modals-container>
    </div>
</template>

<script>
export default {
    name: 'cart',
}
</script>

<script setup>
import { ref, onMounted, inject, nextTick } from 'vue';
import SvgSymbol from '@js/components/ui/svg-symbol';
import ModalOrder from '@js/components/ui/modals/modal-order';
import ModalComment from '@js/components/ui/modals/modal-comment';

const modals = ref({
    order: null,
    comment: null,
});
const modalsApi = inject('modalsApi');
const status = ref({
    success: false,
    error: false,
    deleting: false,
    loading: true
})

const items = ref([]);

onMounted(async () => {
    await getItems();
    
    if (window.location.hash == '#order' && items.value.length) {
        send()
    };
});

const send = () => {
    if (modalsApi.get(modals.value.order).length) return;

    modals.value.order = modalsApi.show({
        component: ModalOrder,
        bind: {
            items: items.value,
        },
        on: {
            "close": () => {
                modalsApi.close(modals.value).order;
            },
        }
    })
}

const editComment = (item, index) => {
    if (modalsApi.get(modals.value.comment).length) return;

    modals.value.comment = modalsApi.show({
        component: ModalComment,
        bind: {
            comment: item.comment,
            index: index,
            items: items.value,
        },
        on: {
            "close": () => {
                modalsApi.close(modals.value.comment);
            },
            "update": (newComment) => {
                item.comment = newComment;

                nextTick(() => {
                    modalsApi.close(modals.value.comment);
                })
            }
        }
    })
}

const deleteItem = async (index) => {
    status.value.deleting = true;

    await axios.post('cart/delete/item', {index: index})
        .then(response => {
            status.value.deleting = false;
            items.value.splice(index, 1);
            emitter.emit('cart-update', response.data.count);
        }).catch(error => {
            alert(error.response?.data.message || error.message);
            status.value.deleting = false;
        })
}

const getItems = async () => {
    await axios.get('cart/items?get')
    .then(response => {
        items.value = response.data || [];
        status.value.loading = false;
    }).catch(error => {
        alert(error.response?.data.message || error.message);
        status.value.loading = false;
    })
}
</script>